import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { getAllMaintenanceTypes } from "../../../redux/MaintenanceTypeSlice/MaintenanceTypeSlice";

export default function MaintenanceTypeSelect({ handleCategorySelect, maintenanceItem }) {
  const dispatch = useDispatch();
  const { allMaintenanceType } = useSelector((state) => state.maintenanceType);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    dispatch(getAllMaintenanceTypes());
  }, [dispatch]);

  useEffect(() => {
    if (allMaintenanceType) {
      const options = allMaintenanceType.map((maintenanceType) => ({ value: maintenanceType.name, label: maintenanceType.name }));
      setCategoryOptions(options);
    }
  }, [allMaintenanceType]);

  const handleCategoryChange = (selectedOption) => {
    handleCategorySelect(selectedOption);
  };
  return (
    <>
      <label htmlFor="category"> نوع الصيانة </label>
      <Select
        id="category"
        name="category"
        options={categoryOptions}
        isSearchable
        onChange={(selectedOption) => handleCategoryChange(selectedOption)}
        placeholder="اختر نوع الصيانة"
        value={{ value: maintenanceItem?.category, label: maintenanceItem?.category }}
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </>
  );
}
